import styled from "styled-components";

const RoundedProfilePic = styled.div<{ bg: string; error?: boolean; outline?: boolean}>`
  background-image: url(${(props) => props.bg});
  width: 100px;
  height: 100px;
  -webkit-border-radius: 60px;
  -webkit-background-clip: padding-box;
  -moz-border-radius: 60px;
  -moz-background-clip: padding;
  border-radius: 60px;
  background-clip: padding-box;
  margin: 7px 0 0 5px;
  float: left;
  background-size: cover;
  background-position: center center;
  border: ${(props) => props.outline ? (props.theme.themeType === "dark" ? 
    props.error ? "2px solid #FB4EFF" : "1px solid white" :  "3px solid #9D7CFF") : ""};
`;

export default RoundedProfilePic;
